"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = on;
const Druid_1 = require("../../Druid");
const Selectors_1 = require("../../Utility/Selectors");
/**
 * The decorator for registering event listener info to the method.
 * @param eventName The event name
 * @param role The data role selector. Role can be prefixed with a specific match pattern. See SelectorHelper
 * @param options add some extra options to the event
 * @see SelectorHelper.createDataRoleSelector
 */
function on(eventName, role, options) {
    return (target, propertyKey, descriptor) => {
        if (descriptor.value === undefined) {
            return;
        }
        const framework = Druid_1.default.getViewFramework();
        framework.registerFunctionDecorator(target, {
            fn: descriptor.value,
            propertyKey: propertyKey,
            decorator: (component, el, fn) => {
                var _a;
                // istanbul ignore next
                const selector = (_a = Selectors_1.default.createDataRoleSelector(role)) !== null && _a !== void 0 ? _a : '*';
                el.addDelegateListener(eventName, selector, evt => framework.getOnEventHandler().handleEvent(component, fn, evt, options));
            }
        });
    };
}
//# sourceMappingURL=On.js.map